// SkyTracker @skytracker/web — bottom status bar (counts + feed status chips).
import { useFleet } from '../store/useFleet.js';

export function StatusBar(): JSX.Element {
  const fleet = useFleet((s) => s.fleet);
  const feed = useFleet((s) => s.feedStatus);
  const truncated = useFleet((s) => s.truncated);

  return (
    <footer className="statusbar">
      <span>{fleet.size.toLocaleString()} OBJECTS</span>
      {truncated && (
        <span className="status-chip degraded">
          {(truncated.count - fleet.size).toLocaleString()} OUTSIDE BUDGET
        </span>
      )}
      {feed.length === 0 && <span className="status-chip degraded">NO FEED STATUS YET</span>}
      {feed.map((f) => (
        <span key={f.source} className={`status-chip ${f.state}`}>
          {f.source}: {f.state}
        </span>
      ))}
      <span style={{ marginLeft: 'auto', opacity: 0.6 }}>
        + / − ZOOM · H HOME · G GLOBE · DRAG ROTATE
      </span>
    </footer>
  );
}
